var _rect, _path, _path2, _path3, _g, _path4, _circle, _circle2, _g2, _ellipse, _circle3, _ellipse2, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventAttended5X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 120,
    viewBox: "0 0 72 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Medal Purple",
    filter: "url(#filter0_d_3684_50750)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24",
    x: 30.7773,
    y: 42.6758,
    width: 6.89191,
    height: 11.7418,
    rx: 3.44595,
    fill: "#C09525"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 23",
    d: "M62.6836 43.0962C62.6836 44.7086 61.3765 46.0156 59.7642 46.0156L8.93621 46.0156C7.32386 46.0156 6.0168 44.7086 6.0168 43.0962L6.0168 33.8749C6.0168 32.2626 7.32387 30.9555 8.9362 30.9555L12.9042 30.9555L12.9042 38.8685L55.7962 38.8685L55.7962 30.9555L59.7642 30.9555C61.3765 30.9555 62.6836 32.2626 62.6836 33.8749L62.6836 43.0962Z",
    fill: "#836600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25",
    d: "M62.6836 42.149C62.6836 43.7613 61.3765 45.0684 59.7642 45.0684L8.93621 45.0684C7.32386 45.0684 6.0168 43.7613 6.0168 42.149L6.0168 32.9277C6.0168 31.3153 7.32387 30.0083 8.9362 30.0083L12.9042 30.0083L12.9042 37.9212L55.7962 37.9212L55.7962 30.0083L59.7642 30.0083C61.3765 30.0083 62.6836 31.3153 62.6836 32.9277L62.6836 42.149Z",
    fill: "#F4CC3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22",
    d: "M55.793 38.0918L12.91 38.0918L12.91 0.694897L34.3515 0.694902L55.793 0.694901L55.793 38.0918Z",
    fill: "#AA75CB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 21",
    d: "M42.5586 38.0937L26.1429 38.0937L26.1429 0.696856L42.5586 0.696857L42.5586 38.0937Z",
    fill: "#73488D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22_2",
    opacity: 0.5,
    d: "M55.8281 5.91211L12.6759 5.9121L12.6759 0.69591L55.8281 0.695913L55.8281 5.91211Z",
    fill: "url(#paint0_linear_3684_50750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 23_2",
    d: "M13.1504 35.3125H55.8284V38.1577H13.1504L13.1504 35.3125Z",
    fill: "url(#paint1_linear_3684_50750)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M32.77 49.8682C33.6209 49.1374 34.8779 49.1374 35.7288 49.8682L40.2012 53.7092C40.7486 54.1793 41.4869 54.3612 42.19 54.1994L47.9352 52.8768C49.0282 52.6251 50.1412 53.2093 50.555 54.2518L52.7302 59.7313C52.9964 60.4019 53.5655 60.9061 54.2633 61.0895L59.965 62.5883C61.0498 62.8735 61.7639 63.908 61.6458 65.0234L61.0254 70.886C60.9494 71.6036 61.219 72.3145 61.7517 72.8012L66.1038 76.7781C66.9318 77.5347 67.0833 78.7825 66.4604 79.7153L63.1865 84.6181C62.7858 85.2181 62.6942 85.9729 62.9396 86.6514L64.9451 92.1953C65.3266 93.25 64.8809 94.4253 63.8959 94.9618L58.7185 97.7815C58.0849 98.1266 57.653 98.7524 57.555 99.4672L56.7544 105.308C56.6021 106.419 55.6612 107.253 54.5397 107.27L48.645 107.361C47.9235 107.372 47.2503 107.725 46.8313 108.313L43.408 113.112C42.7568 114.026 41.5363 114.326 40.5353 113.82L35.2736 111.161C34.6296 110.836 33.8693 110.836 33.2253 111.161L27.9636 113.82C26.9625 114.326 25.7421 114.026 25.0908 113.112L21.6675 108.313C21.2486 107.725 20.5753 107.372 19.8539 107.361L13.9591 107.27C12.8376 107.253 11.8968 106.419 11.7445 105.308L10.9439 99.4672C10.8459 98.7524 10.414 98.1266 9.7803 97.7815L4.60295 94.9618C3.61794 94.4253 3.17221 93.25 3.55376 92.1953L5.55921 86.6514C5.80466 85.9729 5.71302 85.2181 5.31232 84.6181L2.03841 79.7153C1.41554 78.7825 1.56705 77.5347 2.39505 76.7781L6.74714 72.8012C7.2798 72.3145 7.54942 71.6036 7.47348 70.886L6.85302 65.0234C6.73498 63.908 7.44903 62.8735 8.53379 62.5883L14.2355 61.0895C14.9334 60.9061 15.5025 60.4019 15.7687 59.7313L17.9438 54.2518C18.3576 53.2093 19.4706 52.6251 20.5637 52.8768L26.3088 54.1994C27.012 54.3612 27.7502 54.1793 28.2976 53.7092L32.77 49.8682Z",
    fill: "url(#paint2_linear_3684_50750)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 34.2225,
    cy: 81.9686,
    r: 23.6112,
    fill: "#705100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3684_50750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 60,
    width: 49,
    height: 49
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 35.4845,
    cy: 84.4884,
    r: 23.6661,
    fill: "#C28B37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3684_50750)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 34.2228,
    cy: 81.9669,
    r: 23.6661,
    fill: "#E3A504"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 11",
    cx: 34.8924,
    cy: 83.1492,
    rx: 18.5896,
    ry: 18.8895,
    fill: "#A36D1D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    opacity: 0.8,
    cx: 34.8923,
    cy: 82.8493,
    r: 17.3903,
    fill: "url(#paint3_linear_3684_50750)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 9",
    cx: 35.1933,
    cy: 82.8486,
    rx: 9.89448,
    ry: 10.1943,
    fill: "#B5760C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    opacity: 0.8,
    cx: 35.1913,
    cy: 82.5487,
    r: 9.29481,
    fill: "url(#paint4_linear_3684_50750)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3684_50750",
    x: 1.32143,
    y: 0.360492,
    width: 70.5446,
    height: 118.726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.34375,
    dy: 2.34375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.33928
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3684_50750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3684_50750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3684_50750",
    x1: 34.252,
    y1: 5.91211,
    x2: 34.252,
    y2: 0.695911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73488D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73488D",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3684_50750",
    x1: 34.4894,
    y1: 35.3125,
    x2: 34.4894,
    y2: 38.1577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73488D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73488D",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3684_50750",
    x1: 34.2494,
    y1: 48.5977,
    x2: 34.2494,
    y2: 115.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A96500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3684_50750",
    x1: 34.8923,
    y1: 65.459,
    x2: 34.8923,
    y2: 100.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D79B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3684_50750",
    x1: 35.1913,
    y1: 73.2539,
    x2: 35.1913,
    y2: 91.8435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFDA95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#FFE2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D224"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventAttended5X);
export default __webpack_public_path__ + "static/media/Event_attended_5x.30285cc2ea9d45d6a87fd10fb5368888.svg";
export { ForwardRef as ReactComponent };